module.exports = "\r\n.p-30px{\r\n  padding: 30px\r\n}\r\n"